import { render, staticRenderFns } from "./userAddress.vue?vue&type=template&id=e74ba622&scoped=true"
import script from "./userAddress.vue?vue&type=script&lang=js"
export * from "./userAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74ba622",
  null
  
)

export default component.exports